import { Form, FormInstance } from "antd";
import { useCallback, useState } from "react";
import { MessagesService } from "../../../../../services/messages";
import { IMessage } from "../../../types/Message";
import { useAppDispatch } from "../../../../../store";
import { setErrorMessage } from "../../../../../acions/actionsCreators/messageActions";

export const useSend = (conversationId: string | undefined) => {
  const dispatch = useAppDispatch();

  const [isSending, setIsSending] = useState<boolean>(false);

  const [form]: FormInstance[] = Form.useForm();

  const [respose, setResponse] = useState<IMessage | null>(null);

  const send = useCallback(async () => {
    try {
      if (conversationId) {
        const values = await form.validateFields();

        const { attachment, text } = values;

        setIsSending(true);

        const request: any = {
          text: text || null,
        };

        if (attachment) {
          request.fileItemIds = attachment.map((item: any) => item.response);
        }

        const res = await MessagesService.send(request, conversationId);

        setResponse(res);
      }
    } catch (e: any) {
      const data = e.response.data;

      if (data.errors) {
        const title = Object.keys(data.errors)[0];

        dispatch(setErrorMessage(data.errors[title][0], true));
      } else {
        dispatch(setErrorMessage(data.title, true));
      }
      setIsSending(false);
    }
  }, [conversationId, form, dispatch]);

  const onMsgSent = useCallback(() => {
    setResponse(null);
    setIsSending(false);
    form.resetFields();
  }, [form]);

  return { form, respose, isSending, onMsgSent, send };
};
